import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Loader2 } from 'lucide-react';

interface ImportProgressProps {
  visible: boolean;
  stage: string;
  percent: number;
  estimatedTime: number;
}

export const ImportProgress: React.FC<ImportProgressProps> = ({
  visible,
  stage,
  percent,
  estimatedTime
}) => {
  if (!visible) return null;
  
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
            <div>
              <h3 className="font-semibold text-foreground">Importing Data</h3>
              <p className="text-sm text-muted-foreground">{stage}</p>
            </div>
          </div>
          <Progress value={percent} className="h-2" />
          <p className="text-xs text-muted-foreground text-center">
            Estimated time remaining: {Math.ceil(estimatedTime * (100 - percent) / 100)}s
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
